import { getFullUrl } from 'hubspot-url-utils';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import styled from 'styled-components';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { getInlineMeetingParams } from '../common/api/meetingHelpers';
import { StyledModal } from '../common/components/StyledModal';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { track } from '../common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TRUSTED_DOMAINS = ['https://www.hubspot.com', 'https://hubspot.com', getFullUrl('app', {
  envOverride: 'prod'
}), getFullUrl('meetings', {
  envOverride: 'prod'
}), getFullUrl('meetings', {
  envOverride: 'qa'
})];
const StyledIframe = styled.iframe.withConfig({
  displayName: "MeetingModal__StyledIframe",
  componentId: "sc-8iroya-0"
})(({
  theme
}) => ({
  border: theme.space['0'],
  width: '900px',
  height: '800px'
}));
const MeetingModal = ({
  hideBackground,
  onClose,
  upgradeData,
  repInfo
}) => {
  const {
    link: linkBase
  } = repInfo;
  const meetingLink = `${linkBase}?${getInlineMeetingParams(upgradeData, repInfo)}`;
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'shown booking page',
      meetingLink,
      repName: getRepName(repInfo)
    }, getUpgradeDataTrackingProperties(upgradeData)));
    const handleMessages = e => {
      const isKnownOrigin = TRUSTED_DOMAINS.includes(e.origin);
      if (!isKnownOrigin) return;
      if (e.data.meetingBookSucceeded) {
        track('communicationMethodsInteraction', Object.assign({
          action: 'meeting booked successfully',
          meetingLink,
          repName: getRepName(repInfo)
        }, getUpgradeDataTrackingProperties(upgradeData)));
      }
    };
    window.addEventListener('message', handleMessages);
    return () => window.removeEventListener('message', handleMessages);
  }, [upgradeData, meetingLink, repInfo]);
  return /*#__PURE__*/_jsxs(StyledModal, {
    "data-test-id": "meeting-modal",
    use: "conversational",
    width: 900,
    hideBackground: hideBackground,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      })
    }), /*#__PURE__*/_jsx(StyledIframe, {
      id: "meetingModal",
      "data-test-id": "tts-modal",
      src: meetingLink
    })]
  });
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
MeetingModal.defaultProps = {
  hideBackground: false
};
MeetingModal.propTypes = Object.assign({
  hideBackground: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  repInfo: PropTypes.object
}, upgradeDataPropsInterface);
export default MeetingModal;